/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.com/docs/use-static-query/
 */

import React from "react";
import PropTypes from "prop-types";
import { useStaticQuery, graphql } from "gatsby";
import { SEOContext } from "gatsby-plugin-wpgraphql-seo";

import Header from "./header";
import Footer from "./Footer";
import ScrollToTop from "./scroll-to-top";

const Layout = ({ children, containerClasses = "" }) => {

  const data = useStaticQuery(graphql`
    query SiteInfoQuery {
      site {
        siteMetadata {
          title
        }
      }
      wp {
        seo {
          contentTypes {
            post {
              title
              schemaType      
              metaDesc
            }
            page {
              metaDesc
              schemaType
              title
            }
          }
          webmaster {
            googleVerify
            yandexVerify
            msVerify
            baiduVerify
          }
          schema {
            companyName
            personName
            companyOrPerson
            wordpressSiteName
            siteUrl
            siteName
            inLanguage
            logo {
              sourceUrl
              mediaItemUrl
              altText
            }
          }
          social {
            facebook {
              url
              defaultImage {
                sourceUrl
                mediaItemUrl
              }
            }
            instagram {
              url
            }
            linkedIn {
              url
            }
            mySpace {
              url
            }
            pinterest {
              url
              metaTag
            }
            twitter {
              username
            }
            wikipedia {
              url
            }
            youTube {
              url
            }
          }
        }
      }
      allWpMenu {
        nodes {
          menuItems {
            nodes {
              url
              id
              label
            }
          }
          locations
        }
      }
    }
  `);

  return (
    <>
      {/* <SEOContext.Provider value={{ global: data.wp?.seo }}> */}
        <Header siteTitle={data?.site?.siteMetadata?.title || `Title`} />
        <div className={`container ${containerClasses}`}>
          <main>{children}</main>
        </div>
        <ScrollToTop />
        <Footer siteTitle={data?.site?.siteMetadata?.title} wpMenu={data.allWpMenu.nodes} />
      {/* </SEOContext.Provider> */}
    </>
  );
};

Layout.propTypes = {
  children: PropTypes.node.isRequired,
};

const WrapperLayout = ({ children, containerClasses, seo }) => (
  <SEOContext.Provider value={{ global: seo }}>
    <Layout children={children} containerClasses={containerClasses} />
  </SEOContext.Provider>
);

export default WrapperLayout;
